import { render } from "./OptionsMenuComponent.vue?vue&type=template&id=52cbdbde&scoped=true"
import script from "./OptionsMenuComponent.vue?vue&type=script&lang=js"
export * from "./OptionsMenuComponent.vue?vue&type=script&lang=js"

import "./OptionsMenuComponent.vue?vue&type=style&index=0&id=52cbdbde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52cbdbde"]])

export default __exports__